<template>
  <div
    class="jackpot-banner-v4__digits"
    :style="digitsStyle"
    :aria-label="formatted"
    aria-live="polite"
  >
    <template v-for="(item, index) in displayItems">
      <span
        v-if="item.type === 'comma'"
        :key="'c-' + index"
        class="jackpot-banner-v4__comma"
        aria-hidden="true"
      >,</span>
      <span
        v-else
        :key="'d-' + index"
        class="jackpot-banner-v4__digit"
        :class="{ 'jackpot-banner-v4__digit--roll': item.roll }"
        aria-hidden="true"
      >
        <span>{{ item.char }}</span>
      </span>
    </template>
  </div>
</template>

<script>
import { formatJackpotAmount } from '@/utils/jackpot'
import { JACKPOT_REEL_CELL_H } from '@/utils/jackpotDisplay'

export default {
  name: 'JackpotV4Digits',

  props: {
    amount: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      previousText: '',
      textResetTimer: null
    }
  },

  computed: {
    formatted () {
      return formatJackpotAmount(this.amount)
    },
    displayItems () {
      const text = this.formatted
      const prev = this.previousText
      const items = []

      for (let i = 0; i < text.length; i++) {
        const ch = text[i]
        if (ch === ',') {
          items.push({ type: 'comma', char: ch, roll: false })
        } else {
          items.push({
            type: 'digit',
            char: ch,
            roll: prev.length > 0 && prev[i] !== ch
          })
        }
      }

      return items
    },
    digitCount () {
      return this.displayItems.filter(item => item.type === 'digit').length
    },
    digitsStyle () {
      let scale = 1
      if (this.digitCount > 11) scale = 0.68
      else if (this.digitCount > 9) scale = 0.78
      else if (this.digitCount > 7) scale = 0.88
      return {
        '--digit-scale': String(scale),
        '--reel-cell-h': `${JACKPOT_REEL_CELL_H}px`
      }
    }
  },

  watch: {
    amount: {
      immediate: true,
      handler (next, prev) {
        if (prev === undefined) {
          this.previousText = this.formatted
          return
        }
        if (this.textResetTimer) {
          clearTimeout(this.textResetTimer)
        }
        this.textResetTimer = window.setTimeout(() => {
          this.previousText = this.formatted
          this.textResetTimer = null
        }, 600)
      }
    }
  },

  beforeDestroy () {
    if (this.textResetTimer) {
      clearTimeout(this.textResetTimer)
      this.textResetTimer = null
    }
  }
}
</script>
